import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=3f68e582&scoped=true&"
import script from "./ShiftList.vue?vue&type=script&lang=ts&"
export * from "./ShiftList.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftList.vue?vue&type=style&index=0&id=3f68e582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f68e582",
  null
  
)

component.options.__file = "ShiftList.vue"
export default component.exports